import React from 'react';
import MessagingThread from '../MessagingThread';
import ConversationThread from './ConversationThread';

/**
 * ConversationSwitcher — Feature-flagged wrapper.
 *
 * Default behavior (Jun 2026): renders ConversationThread UNLESS the env var
 * `REACT_APP_ENABLE_CONVERSATION_FIRST` is explicitly set to the string
 * `"false"`. This makes native iOS builds (where the env var may be absent
 * from a contributor's local .env.production) safe-by-default — they now
 * pick up the new chat experience without requiring per-machine env setup.
 *
 * To explicitly fall back to the legacy MessagingThread, set:
 *   REACT_APP_ENABLE_CONVERSATION_FIRST=false
 *
 * Same props API as MessagingThread so it's a drop-in replacement.
 */
const RAW_FLAG = process.env.REACT_APP_ENABLE_CONVERSATION_FIRST;
const CONVERSATION_FIRST_ENABLED = RAW_FLAG !== 'false';

// Expose the decision so the runtime diagnostic marker can read it
// without depending on this module.
try {
  if (typeof window !== 'undefined') {
    window.__CELEY_CHAT_SWITCHER = {
      rawFlag: RAW_FLAG === undefined ? 'undefined' : String(RAW_FLAG),
      branch: CONVERSATION_FIRST_ENABLED ? 'ConversationThread' : 'MessagingThread',
    };
  }
} catch (_) { /* noop */ }

const ConversationSwitcher = (props) => {
  if (CONVERSATION_FIRST_ENABLED) {
    return <ConversationThread {...props} __diagSwitcherFlagRaw={RAW_FLAG === undefined ? 'undefined' : String(RAW_FLAG)} __diagSwitcherBranch="ConversationThread" />;
  }
  return <MessagingThread {...props} __diagSwitcherFlagRaw={RAW_FLAG === undefined ? 'undefined' : String(RAW_FLAG)} __diagSwitcherBranch="MessagingThread" />;
};

export default ConversationSwitcher;
